module.exports = "/src/views/player/hudevo/phonenew/assets/images/trucker.png";